import apiClient from "./client";
import { ENDPOINTS } from "./endpoints";

export const fetchStateCityAll = () => apiClient.get(ENDPOINTS.common.stateCityAll);

// Plain file upload (no rem_lead_docs row) — returns the stored file's URL, for
// forms whose save API takes the document as a URL (e.g. save_contract's
// contract_signed_docs). Response: { status, data: [{ file_url, ... }] }.
// LOCAL TESTING ONLY: the local gateway can't reach docs_upload, so dev builds
// post it straight to the stage gateway. Production builds keep the relative
// path (BASE_URL). Remove once the local gateway routes it.
const DOCS_UPLOAD_URL = ENDPOINTS.common.docsUpload;

export const uploadFileToStorage = async (file, leadId) => {
  const formData = new FormData();
  formData.append("upload_type", "rem_docs");
  if (leadId) formData.append("lead_id", leadId);
  formData.append("images", file);
  const { data } = await apiClient.post(DOCS_UPLOAD_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const url = data?.data?.[0]?.file_url;
  if (!url) throw new Error(data?.message || "Upload failed");
  return url;
};

// Confirmed shape: { status, message, data: { state: [{id,name}], city: [{id,name,state_id}] } }
export const normalizeStateCity = (raw) => {
  const data = raw?.data || {};
  const states = (data.state || []).map((s) => ({ id: s.id, label: s.name, value: String(s.id) }));
  const cities = (data.city || []).map((c) => ({
    id: c.id,
    label: c.name,
    value: String(c.id),
    state_id: String(c.state_id),
  }));
  return { state_list: states, city_list: cities };
};
